var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 23.0992C28.4676 18.4463 26.1743 14.158 22.7168 10.8451C21.9599 10.1297 21.5821 9.77267 20.7461 9.44271C19.9102 9.11133 19.1913 9.11133 17.755 9.11133H14.5985C13.1622 9.11133 12.4433 9.11133 11.6073 9.44271C10.7728 9.77267 10.3921 10.1297 9.63667 10.8451C6.17917 14.158 3.88589 18.4463 3.08343 23.0992C2.37042 27.2777 6.33808 30.4451 10.7713 30.4451H21.5821C26.0168 30.4451 29.986 27.2777 29.2686 23.0992",
    stroke: "#2C6199",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23396 5.47456C8.93089 5.04788 8.49313 4.4676 9.39794 4.33676C10.3276 4.20022 11.2925 4.81748 12.2383 4.8061C13.0918 4.7933 13.5267 4.42494 13.9952 3.8987C14.4871 3.34545 15.2484 2 16.1781 2C17.1078 2 17.8691 3.34545 18.3611 3.8987C18.8296 4.42494 19.2644 4.79472 20.118 4.80468C21.0638 4.8189 22.0286 4.20022 22.9583 4.33533C23.8631 4.4676 23.4253 5.04646 23.1223 5.47313L21.7577 7.40597C21.1721 8.23088 20.8808 8.64333 20.2688 8.878C19.6568 9.11267 18.8676 9.11125 17.2879 9.11125H15.0683C13.4871 9.11125 12.698 9.11125 12.0875 8.878C11.4769 8.64475 11.1841 8.22945 10.5985 7.40455L9.23396 5.47456Z",
    stroke: "#2C6199",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5572 17.5292C18.241 16.3929 16.629 15.3689 14.6949 16.1354C12.7609 16.902 12.4549 19.3668 15.3787 19.6299C16.7022 19.748 17.5631 19.492 18.3522 20.2159C19.1428 20.9384 19.2892 22.9509 17.2703 23.4927C15.2542 24.0346 13.2557 23.1884 13.0391 21.9852M15.9438 14.7886V15.8709M15.9438 23.6591V24.7457",
    stroke: "#2C6199",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/Cost.efbd9aadb21f8dbd6771d8e2b6b494c5.svg";
export { ForwardRef as ReactComponent };